/**
 * Create a Point object
 * @param  {Number} x x-coordinate of point
 * @param  {Number} y y-coordinate of point
 * @return {Object}   point object with x and y properties
 */
export function makePoint(x, y) {
    return {
        x: x,
        y: y
    };
}

/**
 * Is the given point in the rectangle or on one of its edges?
 * @param  {Object} point point object with x and y properties
 * @param  {Object} rect  rectangle object with top/right/bottom/left properties
 * @return {Boolean}      true if point is in the rectangle or on one of its edges, false otherwise
 */
export function pointInRect(point, rect) {
    return (point.x >= rect.left) &&
        (point.x <= rect.right) &&
        (point.y >= rect.bottom) &&
        (point.y <= rect.top);
}

/**
 * Do 2 rectangles intersect or overlap in any way
 * @param  {Object} rect1 rectangle object with top/right/bottom/left properties
 * @param  {Object} rect2 rectangle object with top/right/bottom/left properties
 * @return {Boolean}      true if rectangles intersect, false otherwise
 */
export function rectsIntersect(rect1, rect2) {
    const topLeft = makePoint(rect1.left, rect1.top);
    const topRight = makePoint(rect1.right, rect1.top);
    const bottomLeft = makePoint(rect1.left, rect1.bottom);
    const bottomRight = makePoint(rect1.right, rect1.bottom);

    return pointInRect(topLeft, rect2) ||
        pointInRect(topRight, rect2) ||
        pointInRect(bottomLeft, rect2) ||
        pointInRect(bottomRight, rect2);
}

/**
 * Does the given DOM element intersect with the browser's viewport?
 * @param  {Object}  element DOM element
 * @return {Boolean}         true if the element intersects with the viewport, false otherwise
 */
export function isElementVisibleInViewport(element) {
    if (!element) {
        return false;
    }

    const elementRect = element.getBoundingClientRect();
    const viewportRect = {
        bottom: 0,
        left: 0,
        top: $(window).height(),
        right: $(window).width()
    };

    return rectsIntersect(elementRect, viewportRect);
}
